import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { useHandleMainDetailsScreenNavigation } from '@v2/pages/common/hooks/useHandleMainDetailsScreenNavigation';
import { ToolLevelSubScreen } from '@v2/pages/tools/details/common/enums/toolsDetails.enum';
import { Perspective } from '@v2/pages/common/enums';
import { BatchDetailsScreenName } from '@v2/pages/batch/details/navigation/config';
import { BatchDetailsScreen } from '@v2/pages/batch/details/common/enums/batchDetails.enum';
import { selectSelectedItem } from '@reducers/machines';
import { Machine } from '@interfaces/machines';
import { ProductionBatchStatistics } from '@interfaces/search';
import { selectSingleBatch } from '@reducers/batch';
import { OEE_TOOLS_BLOCK_CONFIG } from '@v2/pages/machines/modules/now/components/Overview/constants';
import { useBatchLoaded } from '@v2/pages/machines/modules/now/components/Overview/hooks/useBatchLoaded';

export const useManageToolsBlock = () => {
  const batch: ProductionBatchStatistics = useSelector(selectSingleBatch);
  const selectedMachine: Machine = useSelector(selectSelectedItem);
  const { navigateToMainDetailsScreen } = useHandleMainDetailsScreenNavigation();
  const batchLoaded = useBatchLoaded();

  const ncFileStatus = selectedMachine?.machineStatus?.ncFileStatus;

  const batchId = batch?.productionBatchId;
  const batchNumber = batch?.batchNumber;

  const { gapBetweenLines } = OEE_TOOLS_BLOCK_CONFIG;

  const handlePress = useCallback(() => {
    navigateToMainDetailsScreen({
      mainScreen: BatchDetailsScreenName,
      subScreen: BatchDetailsScreen.TOOLS,
      levelSubScreen: ToolLevelSubScreen.GENERAL,
      params: {
        perspective: Perspective.BATCH,
        batchId,
        batchNumber,
        ncFileStatus,
      },
    });
  }, [navigateToMainDetailsScreen, batchId, batchNumber, ncFileStatus]);

  return {
    gapBetweenLines,
    handlePress,
    batchLoaded,
  };
};
